/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import { Box, Flex } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import SimpleButton from '@components/Buttons/SimpleButton';
import config from '@config';

/* Services */
import { isVisInViewport } from '@components/Utility/Shared/SharedService';
import { IoLogoWhatsapp } from 'react-icons/io5';
import WPChatButton from './WPChatButton';
import InlineEnquireForm from './InlineEnquireForm';
import { usePathname } from 'next/navigation';
import { mixPanel } from '@utils/Mixpanel';

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */
const RegisterStickyButtonWOB = ({
  sectionContent,
  region,
  lang,
  pageData,
}) => {
  const pathname = usePathname();
  const [isPopup, setIsPopup] = useState(false);

  const isWavesOfBlissWAPage =
    pathname.endsWith('wave-of-bliss-bengaluru-wa') ||
    pathname.endsWith('wave-of-bliss-uttar-pradesh-wa');
  const isWavesOfBlissILPage =
    pathname.endsWith('wave-of-bliss-bengaluru-il') ||
    pathname.endsWith('wave-of-bliss-uttar-pradesh-il');
  const isWavesOfBlissLandingPage =
    pathname.endsWith('wave-of-bliss-bengaluru') ||
    pathname.endsWith('wave-of-bliss-uttar-pradesh');
  const isWavesOfBlissUPPage = pathname.includes('wave-of-bliss-uttar-pradesh');

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', listenToScroll);
    return () => window.removeEventListener('scroll', listenToScroll);
  }, []);

  const mixPanelEventTrigger = () => {
    const Mixpanel = mixPanel(window?.location.pathname);
    if (isWavesOfBlissLandingPage) {
      Mixpanel.track('ie_wave_registration_cta_click', {
        element: 'REGISTER NOW',
        language: config?.lngList?.[lang],
        cta: 'sticky cta',
      });
    }
    if (isWavesOfBlissWAPage) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'ie_wave_lead_wa_button_clicked',
        program_name: isWavesOfBlissUPPage ? 'IE Wave - UP' : 'IE Wave - BLR',
        Button_Location: 'Sticky CTA',
      });
      Mixpanel.track('ie_wave_chat_with_us_click', {
        page_name: 'Whatsapp Bot page',
        element: 'Chat with us',
        language: config?.lngList?.[lang],
        cta: 'sticky cta',
      });
    }
    if (isWavesOfBlissILPage) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'ie_wave_lead_web_button_clicked',
        program_name: isWavesOfBlissUPPage ? 'IE Wave - UP' : 'IE Wave - BLR',
        Button_Location: 'Sticky CTA',
      });
      Mixpanel.track('ie_wave_enquire_now_click', {
        page_name: 'Inline form page',
        element: 'Enquire Now',
        language: config?.lngList?.[lang],
        cta: 'sticky cta',
      });
    }
  };

  const listenToScroll = () => {
    const bannerDiv = document.getElementById('banner');
    const prgFeesDiv = document.getElementById('ieo-wave-program-registration');
    const footerDiv = document.getElementById('footer');

    const inViewPort = bannerDiv && isVisInViewport(bannerDiv);
    const inFeeViewPort = prgFeesDiv && isVisInViewport(prgFeesDiv);
    const footerInViewPort = footerDiv && isVisInViewport(footerDiv);

    if (inFeeViewPort || inViewPort || footerInViewPort) {
      setIsVisible(false);
    } else {
      setIsVisible(true);
    }
    return;
  };

  const getSimpleButton = () => {
    if (isWavesOfBlissWAPage) {
      return (
        <SimpleButton
          w={'max-content'}
          minW="210px"
          pr="20px"
          background={'#fff !important'}
          h={{ base: '69px' }}
          textAlign="center"
          mb={'0'}
          mt={'0'}
          mx={{ base: 'auto', md: '0', lg: 'auto' }}
          _hover={{
            background: '#fff !important',
          }}
          borderRadius={{
            base: '50px !important',
            md: '50px 0px 0px 50px !important',
          }}
          style={{
            buttonStyle: 'Orange',
            buttonText: (
              <Flex
                color={'#000000'}
                fontSize={'18px'}
                fontWeight={'500'}
                fontFamily={'FedraSansStd-medium'}
                gap={'9px'}
              >
                <Box
                  w="59px"
                  h="59px"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  borderRadius="50px"
                  bg="#00E676"
                >
                  <IoLogoWhatsapp size={38} color="white" />
                </Box>
                {sectionContent[0]?.buttonText}
              </Flex>
            ),
          }}
          srcImg={pageData}
          boxShadow="0px 0.41px 2.2px 0px #73320C0C,
  0px 1.79px 4.56px 0px #73320C13,
  0px 4.4px 9.1px 0px #73320C18,
  0px 8.47px 17.84px 0px #73320C1D,
  0px 14.26px 32.8px 0px #73320C25,
  0px 22px 56px 0px #73320C30;
"
          onClick={(e) => {
            mixPanelEventTrigger();
            if (!isWavesOfBlissLandingPage) {
              setIsPopup(true);
            }
          }}
          padding={{
            base: '5.5px 5.5px',
          }}
          lineHeight={{
            base: '58px',
          }}
          zIndex={100}
          useBlankStringURLOnLink={isWavesOfBlissWAPage || isWavesOfBlissILPage}
        ></SimpleButton>
      );
    }
    return (
      <SimpleButton
        w={{ base: '100%', md: '152px' }}
        h="max-content"
        background={'#F37021 !important'}
        textAlign="center"
        mb={'0'}
        mt={'0'}
        mx={{ base: '0' }}
        _hover={{
          background: '#BC570F !important',
        }}
        borderRadius={{
          base: '5px !important',
          md: '0px !important',
        }}
        style={sectionContent[0]}
        srcImg={pageData}
        onClick={(e) => {
          mixPanelEventTrigger();
          if (!isWavesOfBlissLandingPage) {
            setIsPopup(true);
          }
        }}
        boxShadow="0px 0.41px 2.2px 0px #73320C0C,
  0px 1.79px 4.56px 0px #73320C13,
  0px 4.4px 9.1px 0px #73320C18,
  0px 8.47px 17.84px 0px #73320C1D,
  0px 14.26px 32.8px 0px #73320C25,
  0px 22px 56px 0px #73320C30;
"
        padding={{
          base: '14px 29px',
          md: '16.5px 20px',
        }}
        lineHeight={{
          base: '29px',
        }}
        useBlankStringURLOnLink={isWavesOfBlissWAPage || isWavesOfBlissILPage}
      ></SimpleButton>
    );
  };

  return (
    <>
      {isVisible && (
        <Box
          position="fixed"
          top={{ base: 'unset', md: '30%' }}
          bottom={{ base: '2%', md: 'unset' }}
          zIndex="100"
          right={{ base: '50%', md: '0' }}
          transform={{
            base: 'translateX(50%)',
            md: 'none',
          }}
          boxSizing="content-box"
          display="flex"
          justifyContent="flex-end"
        >
          {getSimpleButton()}
        </Box>
      )}
      {isWavesOfBlissWAPage ? (
        <WPChatButton
          region={region}
          lang={lang}
          isPopup={isPopup}
          setIsPopup={setIsPopup}
          pageData={pageData}
        />
      ) : (
        <InlineEnquireForm
          region={region}
          lang={lang}
          isPopup={isPopup}
          setIsPopup={setIsPopup}
          pageData={pageData}
        />
      )}
    </>
  );
};

export default RegisterStickyButtonWOB;
